import React, { useState } from 'react';
import { notification } from 'components/ds';
import { DynamicForm } from 'modules/account/components/DynamicForm/DynamicForm';
import { useNavigate } from 'react-router-dom';
import { handleApiError } from 'components/ErrorHandler';
import { PasswordForm } from '../../../components/PasswordForm/PasswordForm';
import { usePassword } from '../../../hooks/usePassword';
import { useOtpContext } from '../../../context/OtpContextProvider';
import { RouteEnum } from '../../../constantes/RouteEnum';
import TurnstileCaptcha from 'components/TurnstileCaptcha';

interface PasswordFormValues {
  newPassword: string;
  confirmPassword: string;
}

export const CreatePassword: React.FC = () => {
  const navigate = useNavigate();
  const { recoveryPassword, isLoading } = usePassword();
  const { otpId, otpCode } = useOtpContext();
  const [captchaToken, setCaptchaToken] = useState<string>('');
  const [captchaKey, setCaptchaKey] = useState(0);
  
  const handleVerify = (token: string) => {
    setCaptchaToken(token);
  }
  
  const handleCreatePassword = async ({ newPassword }: PasswordFormValues) => {
    if (!otpId || !otpCode) {
      notification.error({
        message: 'Erro na validação',
        description: 'Informações de validação ausentes. Por favor, solicite um novo código.'
      });

      return;
    }
    
    if (!captchaToken) {
      notification.error({
        message: 'Verificação necessária',
        description: 'Por favor, complete a verificação de segurança.'
      });

      return;
    }
    
    try {
      const success = await recoveryPassword({
        otpId,
        otpCode,
        newPassword,
        captchaToken
      });
      
      if (success) {
        notification.success({
          message: 'Senha criada',
          description: 'Sua senha foi criada com sucesso.'
        });
        navigate(RouteEnum.LOGIN_USERNAME);
      }
    } catch (error: any) {
      // Reset captcha when operation fails
      setCaptchaToken('');
      setCaptchaKey(prev => prev + 1);
      
      handleApiError(error, 'Não foi possível criar sua senha');
    }
  };
  
  return (
    <DynamicForm pageName="createPassword" initialValues={{}}>
      <PasswordForm
        isLoading={isLoading}
        buttonText="Próximo"
        onSubmit={handleCreatePassword}
        captchaComponent={<TurnstileCaptcha onVerify={handleVerify} key={captchaKey} />}
        disableSubmit={!captchaToken}
      />
    </DynamicForm>
  );
};
